import { Form, Spin, Typography } from "antd/es";
import moment from "moment";
import { connect } from "react-redux";
import {
  Button,
  Header,
  Icon,
  KCol,
  KDatePicker,
  KPanel,
  KRow,
  Label,
  TextArea,
} from "../../components/web-components";
import { KSelectBox } from "../../kuika";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { KuikaTabOrderProvider } from "../../shared/hoc/tab-order-provider";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withInlineOverlayNav } from "../../shared/hoc/with-inline-overlay-nav";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { StockCountHeader_ScreenBase } from "./stockcountheader-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class StockCountHeader_Screen extends StockCountHeader_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin
          spinning={
            this.state.spinnerCount > 0 ||
            (!!this.context?.callCallbackFunction &&
              !this.context?.isMasterPageInitLoaded &&
              !this.state.isPageInitLoaded)
          }
        >
          <KuikaTabOrderProvider>
            <Form
              form={this.props.form}
              name="basic"
              component={false}
              initialValues={{
                stockcountheader_803595_value: undefined,
                stockcountheader_653547_value: undefined,
                stockcountheader_497198_value: moment().format(
                  "YYYY-MM-DDTHH:mm:ss"
                ),
                stockcountheader_414152_value: "",
              }}
              onValuesChange={(changedValues, allValues) => {
                this.clearFieldValidation(changedValues);
              }}
            >
              <div
                style={
                  {
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100%",
                  } as any
                }
              >
                <Header
                  key="-2"
                  id="stockcountheader_header"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(255, 255, 255, 1)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      fontFamily: "Poppins",
                      fontWeight: 400,
                      fontSize: "15px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                >
                  <KRow
                    key="994840"
                    id="994840"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12,
                        borderBottomRightRadius: 16,
                        borderBottomLeftRadius: 16,
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <KCol
                      key="984208"
                      id="984208"
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "center",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <Icon
                        key="55183"
                        id="55183"
                        onClick={(e?: any) => {
                          if (e && e.stopPropagation) e.stopPropagation();
                          this.StockCountHeaderComponent_55183_onClick();
                        }}
                        showCursorPointer
                        iconLibrary="material"
                        iconName="arrow_back"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "24px",
                            color: "rgba(0, 0, 0, 1)",
                            letterSpacing: "1px",
                          } as any
                        }
                      ></Icon>
                    </KCol>
                    <KCol
                      key="382410"
                      id="382410"
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "center",
                          textAlign: "-webkit-center",
                        } as any
                      }
                    >
                      <Label
                        key="588591"
                        id="588591"
                        value={ReactSystemFunctions.translate(
                          this.ml,
                          588591,
                          "value",
                          this.defaultML
                        )}
                        writingMode="horizontal"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-center",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 600,
                            fontSize: "15px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      ></Label>
                    </KCol>
                    <KCol
                      key="136316"
                      id="136316"
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                      xxl={8}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "center",
                          textAlign: "-webkit-right",
                        } as any
                      }
                    >
                      <Icon
                        key="674698"
                        id="674698"
                        visibility={this.state.isComp674698Visible}
                        iconLibrary="material"
                        iconName="article"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "inline",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "24px",
                            color: "rgba(0, 0, 0, 1)",
                            letterSpacing: "1px",
                          } as any
                        }
                      ></Icon>
                    </KCol>
                  </KRow>
                </Header>
                <div
                  key="-1"
                  id="stockcountheader_body"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(244, 244, 244, 1)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      display: "block",
                      overflow: "auto",
                      minHeight:
                        "calc(100vh - 92px - 0px - 0px - 0px - 0px - 0px)",
                      maxHeight:
                        "calc(100vh - 92px - 0px - 0px - 0px - 0px - 0px)",
                      height:
                        "calc(100vh - 92px - 0px - 0px - 0px - 0px - 0px)",
                    } as any
                  }
                >
                  <KRow
                    key="489563"
                    id="489563"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <KCol
                      key="715562"
                      id="715562"
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <KPanel
                        key="799888"
                        id="799888"
                        scrolling="hidden"
                        scrollRadius={false}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                          } as any
                        }
                      >
                        <KRow
                          key="439267"
                          id="439267"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderBottomRightRadius: 15,
                              borderBottomLeftRadius: 15,
                              borderBottomWidth: 1,
                              borderColor: "rgba(0, 0, 0, 1)",
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderLeftWidth: 0,
                            } as any
                          }
                        >
                          <KCol
                            key="9262"
                            id="9262"
                            xs={8}
                            sm={8}
                            md={8}
                            lg={8}
                            xl={8}
                            xxl={8}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Label
                              key="690454"
                              id="690454"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                690454,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></Label>
                          </KCol>
                          <KCol
                            key="676428"
                            id="676428"
                            xs={16}
                            sm={16}
                            md={16}
                            lg={16}
                            xl={16}
                            xxl={16}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Form.Item
                              className="kFormItem"
                              name="stockcountheader_803595_value"
                            >
                              <KSelectBox
                                key="803595"
                                id="803595"
                                onChange={(e?: any) => {
                                  if (e && e.stopPropagation)
                                    e.stopPropagation();
                                  this.StockCountHeaderComponent_803595_onChange();
                                }}
                                kuikaRef={
                                  this
                                    .stockcountheader_803595_value_kuikaSelectBoxRef
                                }
                                options={this.state.GetOfficeList}
                                placeholder={ReactSystemFunctions.translate(
                                  this.ml,
                                  803595,
                                  "placeholder",
                                  this.defaultML
                                )}
                                allowClear={false}
                                autoClearSearchValue={true}
                                showSearch={false}
                                widthType="fill"
                                containsNullItem={false}
                                sortBy="none"
                                datavaluefield="officeCode"
                                datatextfield="officeDescription"
                                style={
                                  {
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8,
                                    borderBottomRightRadius: 8,
                                    borderBottomLeftRadius: 8,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "rgba(218, 218, 218, 1)",
                                    borderStyle: "solid",
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "contain",
                                    backgroundPosition: "left",
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "block",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              ></KSelectBox>
                            </Form.Item>
                          </KCol>
                        </KRow>
                        <KRow
                          key="494635"
                          id="494635"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderBottomRightRadius: 15,
                              borderBottomLeftRadius: 15,
                              borderBottomWidth: 1,
                              borderColor: "rgba(0, 0, 0, 1)",
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderLeftWidth: 0,
                            } as any
                          }
                        >
                          <KCol
                            key="350748"
                            id="350748"
                            xs={8}
                            sm={8}
                            md={8}
                            lg={8}
                            xl={8}
                            xxl={8}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Label
                              key="635712"
                              id="635712"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                635712,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></Label>
                          </KCol>
                          <KCol
                            key="633078"
                            id="633078"
                            xs={16}
                            sm={16}
                            md={16}
                            lg={16}
                            xl={16}
                            xxl={16}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Form.Item
                              className="kFormItem"
                              name="stockcountheader_653547_value"
                            >
                              <KSelectBox
                                key="653547"
                                id="653547"
                                kuikaRef={
                                  this
                                    .stockcountheader_653547_value_kuikaSelectBoxRef
                                }
                                options={this.state.GetOfficeWarehouseList}
                                placeholder={ReactSystemFunctions.translate(
                                  this.ml,
                                  653547,
                                  "placeholder",
                                  this.defaultML
                                )}
                                allowClear={false}
                                autoClearSearchValue={true}
                                showSearch={false}
                                widthType="fill"
                                containsNullItem={false}
                                sortBy="none"
                                datavaluefield="warehouseCode"
                                datatextfield="warehouseDescription"
                                style={
                                  {
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8,
                                    borderBottomRightRadius: 8,
                                    borderBottomLeftRadius: 8,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "rgba(218, 218, 218, 1)",
                                    borderStyle: "solid",
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "contain",
                                    backgroundPosition: "left",
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "block",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              ></KSelectBox>
                            </Form.Item>
                          </KCol>
                        </KRow>
                        <KRow
                          key="938166"
                          id="938166"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderBottomRightRadius: 15,
                              borderBottomLeftRadius: 15,
                              borderBottomWidth: 1,
                              borderColor: "rgba(0, 0, 0, 1)",
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderLeftWidth: 0,
                            } as any
                          }
                        >
                          <KCol
                            key="316603"
                            id="316603"
                            xs={8}
                            sm={8}
                            md={8}
                            lg={8}
                            xl={8}
                            xxl={8}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Label
                              key="7671"
                              id="7671"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                7671,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></Label>
                          </KCol>
                          <KCol
                            key="958031"
                            id="958031"
                            xs={16}
                            sm={16}
                            md={16}
                            lg={16}
                            xl={16}
                            xxl={16}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Form.Item
                              className="kFormItem"
                              name="stockcountheader_497198_value"
                            >
                              <KDatePicker
                                key="497198"
                                id="497198"
                                editability={this.state.isComp497198Enabled}
                                kuikaRef={
                                  this
                                    .stockcountheader_497198_value_kuikaDatetimeRef
                                }
                                placeholder={ReactSystemFunctions.translate(
                                  this.ml,
                                  497198,
                                  "placeholder",
                                  this.defaultML
                                )}
                                allowClear={true}
                                format="DD-MM-YYYY HH:mm:ss"
                                use12Hours={false}
                                displayType="datetime"
                                returnDisplayValue={false}
                                style={
                                  {
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8,
                                    borderBottomRightRadius: 8,
                                    borderBottomLeftRadius: 8,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "rgba(218, 218, 218, 1)",
                                    borderStyle: "solid",
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "contain",
                                    backgroundPosition: "left",
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "block",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              ></KDatePicker>
                            </Form.Item>
                          </KCol>
                        </KRow>
                        <KRow
                          key="800767"
                          id="800767"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderBottomRightRadius: 15,
                              borderBottomLeftRadius: 15,
                              borderBottomWidth: 1,
                              borderColor: "rgba(0, 0, 0, 1)",
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderLeftWidth: 0,
                            } as any
                          }
                        >
                          <KCol
                            key="118694"
                            id="118694"
                            xs={8}
                            sm={8}
                            md={8}
                            lg={8}
                            xl={8}
                            xxl={8}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Label
                              key="288"
                              id="288"
                              value={ReactSystemFunctions.translate(
                                this.ml,
                                288,
                                "value",
                                this.defaultML
                              )}
                              writingMode="horizontal"
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "center",
                                  textAlign: "-webkit-left",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 400,
                                  fontSize: "15px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            ></Label>
                          </KCol>
                          <KCol
                            key="803366"
                            id="803366"
                            xs={16}
                            sm={16}
                            md={16}
                            lg={16}
                            xl={16}
                            xxl={16}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Form.Item
                              className="kFormItem"
                              name="stockcountheader_414152_value"
                            >
                              <TextArea
                                key="414152"
                                id="414152"
                                placeholder={ReactSystemFunctions.translate(
                                  this.ml,
                                  414152,
                                  "placeholder",
                                  this.defaultML
                                )}
                                allowClear={false}
                                autoSize={false}
                                showCount={false}
                                formatter="None"
                                readOnly={false}
                                speechToText={false}
                                style={
                                  {
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8,
                                    borderBottomRightRadius: 8,
                                    borderBottomLeftRadius: 8,
                                    borderTopWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    borderLeftWidth: 1,
                                    borderColor: "rgba(218, 218, 218, 1)",
                                    borderStyle: "solid",
                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "contain",
                                    backgroundPosition: "left",
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "block",
                                    fontFamily: "Poppins",
                                    fontWeight: 400,
                                    fontSize: "15px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              ></TextArea>
                            </Form.Item>
                          </KCol>
                        </KRow>
                        <KRow
                          key="777242"
                          id="777242"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                            } as any
                          }
                        >
                          <KCol
                            key="237829"
                            id="237829"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "center",
                                textAlign: "-webkit-right",
                              } as any
                            }
                          >
                            <Button
                              key="656886"
                              id="656886"
                              onClick={(e?: any) => {
                                if (e && e.stopPropagation) e.stopPropagation();
                                this.StockCountHeaderComponent_656886_onClick();
                              }}
                              showCursorPointer
                              label={ReactSystemFunctions.translate(
                                this.ml,
                                656886,
                                "label",
                                this.defaultML
                              )}
                              size="middle"
                              loading={false}
                              ghost={false}
                              block={false}
                              htmlType="button"
                              iconLibrary="material"
                              icon="arrow_right_alt"
                              iconPosition="left"
                              danger={false}
                              style={
                                {
                                  borderTopLeftRadius: 8,
                                  borderTopRightRadius: 8,
                                  borderBottomRightRadius: 8,
                                  borderBottomLeftRadius: 8,
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  backgroundColor: "rgba(225, 60, 57, 1)",
                                  backgroundRepeat: "no-repeat",
                                  backgroundSize: "contain",
                                  backgroundPosition: "left",
                                  paddingTop: 8,
                                  paddingRight: 16,
                                  paddingBottom: 8,
                                  paddingLeft: 16,
                                  alignItems: "center",
                                  textAlign: "-webkit-center",
                                  display: "inline",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "29px",
                                  color: "rgba(255, 255, 255, 1)",
                                  lineHeight: "22px",
                                } as any
                              }
                            ></Button>
                          </KCol>
                        </KRow>
                      </KPanel>
                    </KCol>
                  </KRow>
                </div>
              </div>
            </Form>
          </KuikaTabOrderProvider>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          withInlineOverlayNav(
            connect(
              mapStateToProps,
              mapDispatchToProps
            )(StockCountHeader_Screen)
          )
        )
      )
    )
  )
);
export { tmp as StockCountHeader_Screen };
//export default tmp;
//export { tmp as StockCountHeader_Screen };
